import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const ZData = z.object({
  id: z.string(),
  siteName: z.string(),
  description: z.string(),
  install_date: z.optional(z.string()),
  hierarchyStructure: z.optional(z.any())
})
export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export async function fetchSiteInfo (
  selectedSiteId: string,
  onSuccess: (device: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().SiteManagementCollectionStrings.TableComponent
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/assetrest/api/v2/udp/tiq/sites/${selectedSiteId}`
  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
